import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { IClaimApi } from "./base";
import {
	ClaimTooltipViewResponse,
	QuotationsViewResponse,
	ClaimOrdersViewResponse,
	ClaimSearchGridResponse,
	ClaimGridItemDetailResponse,
	ClaimGridItemPartResponse,
	ClaimItemsToRequoteResponse,
	PrintSupplierPartsReportResponse,
} from "../models/response";
import {
	AddToSendUpdateQueueRequest,
	ClaimSearchRequest,
	PrintSupplierPartsReportRequest,
	RequotePartClaimRequest,
} from "../models/request";
import { KeyValue } from "../models/common";
import { PaginationResponse } from "../models/common/paginationResponse";
import { TimeoutRequestConfigurationEnum } from "../services/enum/TimeoutRequestConfigurationEnum";

const baseRoute: string = "Claim";

export class ClaimApi extends IClaimApi {
	getgridparts(guidClaim: string): Promise<AxiosResponse<Result<ClaimGridItemPartResponse[]>>> {
		return api.get(`${baseRoute}/getgridparts`, {
			params: { guidClaim },
		});
	}
	getItemsToRequote(guidClaim: string): Promise<AxiosResponse<Result<ClaimItemsToRequoteResponse>>> {
		return api.get(`${baseRoute}/getItemsToRequote`, {
			params: { guidClaim },
		});
	}

	requoteItemsClaim(request: RequotePartClaimRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/requoteItemsClaim`, request, {
			timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds,
		});
	}
	getGridItemDetails(guidClaim: string): Promise<AxiosResponse<Result<ClaimGridItemDetailResponse>>> {
		return api.get(`${baseRoute}/getGridItemDetails`, {
			params: { guidClaim },
		});
	}
	getClaimTooltipData(guidClaim: string): Promise<AxiosResponse<Result<ClaimTooltipViewResponse>>> {
		return api.get(`${baseRoute}/getClaimTooltipData`, {
			params: { guidClaim },
		});
	}
	getQuotationsByGuidClaim(guidClaim: string): Promise<AxiosResponse<Result<QuotationsViewResponse[]>>> {
		return api.get(`${baseRoute}/getQuotationsByGuidClaim`, {
			params: { guidClaim },
		});
	}
	getOrdersByGuidClaim(guidClaim: string): Promise<AxiosResponse<Result<ClaimOrdersViewResponse[]>>> {
		return api.get(`${baseRoute}/getOrdersByGuidClaim`, {
			params: { guidClaim },
		});
	}
	searchGrid(request: ClaimSearchRequest): Promise<AxiosResponse<PaginationResponse<ClaimSearchGridResponse>>> {
		return api.post(`${baseRoute}`, request, {
			timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds,
		});
	}

	requotePartsCancelledBySupplier(request: RequotePartClaimRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/RequoteItems`, request, {
			timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds,
		});
	}

	addSendUpdateQueue(request: AddToSendUpdateQueueRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/ManualAddToUpdateIntegrationQueue`, request);
	}

	getSupplierPartsReportSuppliers(guidClaim: string): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/supplier-parts-report-suppliers`, { params: { guidClaim } });
	}

	printSupplierPartsReport(
		request: PrintSupplierPartsReportRequest,
	): Promise<AxiosResponse<Result<PrintSupplierPartsReportResponse>>> {
		return api.post(`${baseRoute}/print-supplier-parts-report`, request, {
			timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds,
		});
	}
}
